export default __webpack_public_path__ + "static/media/will-power-bg.92d7048c.jpg";